import React from 'react';
import { graphql } from 'gatsby';

import AwardsSectionDS from 'design-system/src/components/organisms/AwardsSection';
import { getSrc } from '../../utils/media';

export default function AwardsSection({ awards, ...props }: any) {
    return (
        <AwardsSectionDS
            {...props}
            awards={
                awards?.length
                    ? awards.map((a) => ({
                          ...a,
                          icon: getSrc(a.icon),
                      }))
                    : []
            }
        />
    );
}

export const fragment = graphql`
    fragment DatoCmsAwardsSection on DatoCmsAwardsSection {
        title
        titleTag
        awards {
            icon {
                ...SourceMedia
                gatsbyImageData(height: 144, placeholder: NONE)
            }
            title
            link
        }
    }
`;
